import { z } from 'zod';

export const createTicketSchema = z.object({
	subject: z.string().min(3, 'Tópico deve ter ao menos 3 caracteres'),
	message: z.string().min(10, 'Mensagem deve ter ao menos 10 caracteres'),
});

export type CreateTicketSchemaType = z.infer<typeof createTicketSchema>;

export const addMessageSchema = z.object({
	message: z.string().min(10, 'Mensagem deve ter ao menos 10 caracteres'),
});

export type AddMessageSchemaType = z.infer<typeof addMessageSchema>;
